module.exports = __webpack_public_path__ + "img/homekv6.a69b39c4.jpg";